import { Link } from 'react-router-dom';
import { useSettingsStore } from '@/store/settingsStore';

/** Header mit Dark-Mode- und Sound-Toggle + Settings-Link */
export default function Header() {
  const { darkMode, soundEnabled, toggleDarkMode, toggleSound } = useSettingsStore();

  return (
    <header className="flex items-center justify-between px-6 py-4" data-testid="header">
      <h1
        className="text-2xl font-bold text-indigo-600 dark:text-indigo-300"
        data-testid="app-title"
      >
        🎮 sEVA Lernspiele
      </h1>
      <div className="flex gap-2">
        <Link
          to="/settings"
          className="flex items-center rounded-lg bg-white px-4 py-2 shadow-sm transition hover:shadow-md dark:bg-gray-700"
          aria-label="Einstellungen"
          data-testid="settings-link"
        >
          ⚙️
        </Link>
        <button
          onClick={toggleSound}
          className="rounded-lg bg-white px-4 py-2 shadow-sm transition hover:shadow-md dark:bg-gray-700"
          aria-label={soundEnabled ? 'Sound ausschalten' : 'Sound einschalten'}
          aria-pressed={soundEnabled}
          data-testid="sound-toggle"
        >
          {soundEnabled ? '🔊' : '🔇'}
        </button>
        <button
          onClick={toggleDarkMode}
          className="rounded-lg bg-white px-4 py-2 shadow-sm transition hover:shadow-md dark:bg-gray-700"
          aria-label={darkMode ? 'Dark Mode ausschalten' : 'Dark Mode einschalten'}
          aria-pressed={darkMode}
          data-testid="dark-mode-toggle"
        >
          {darkMode ? '☀️' : '🌙'}
        </button>
      </div>
    </header>
  );
}
